import { Typography, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledTypography = styled(Typography) `
  display: block;
  text-align: center;
  margin-top: ${theme.spacing.xl};
`;
